import { DesignServiceComponent } from './components/design-service/design-service.component';
import { DetailsComponent } from './components/details/details.component';
import { ProductAdditionalInfoComponent } from './components/product-additional-info/product-additional-info.component';
import { ProductEditorComponent } from './components/product-editor/product-editor.component';
import { ProductFlowComponent } from './components/product-flow/product-flow.component';
import { ProductMediaViewerComponent } from './components/product-media-viewer/product-media-viewer.component';
import { ProductPriceComponent } from './components/product-price/product-price.component';
import { TemplateSelectorComponent } from './components/template-selector/template-selector.component';
import { UploadMaterialComponent } from './components/upload-material/upload-material.component';
import { ValidateDesignComponent } from './components/validate-design/validate-design.component';
import { WorkflowSelectorComponent } from './components/workflow-selector/workflow-selector.component';
import { GetProductFlowButtonLabelPipe } from './pipes/get-product-flow-button-label.pipe';
import { GetProductMediaUrlPipe } from './pipes/get-product-media-url.pipe';
import { ResolveProductGuardService } from './services/resolve-product-guard.service';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SchemaFormModule } from '@app/schema-form/schema-form.module';
import { IconComponent } from '@app/shared/components/icon/icon.component';
import { PrintfileReportComponent } from '@app/shared/components/printfile-report/printfile-report.component';
import { VatSelectorComponent } from '@app/shared/components/vat-selector/vat-selector.component';
import { ZoomableImageComponent } from '@app/shared/components/zoomable-image/zoomable-image.component';
import { LocalizedLengthPipe } from '@app/shared/pipes/localized-length.pipe';
import { ContentAccessGuardService } from '@app/shared/services/content-access-guard.service';
import { ResolveStoreService } from '@app/shared/services/resolve-store.service';
import { SharedModule } from '@app/shared/shared.module';
import { DynamicUploadModule } from '@app/upload/upload.module';

const productRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild([
	{
		path: 'sku/:sku',
		pathMatch: 'full',
		children: [],
		canActivate: [ResolveProductGuardService],
	},
	{
		path: ':id',
		canActivate: [ContentAccessGuardService],
		resolve: { data: ResolveStoreService },
		children: [
			{ path: '', component: ProductFlowComponent },
			{ path: ':slug', component: ProductFlowComponent },
			{ path: ':slug/edit/:cartItemId', component: ProductFlowComponent }, // Other components don't know stepKey
			{ path: ':slug/edit/:cartItemId?productList', component: ProductFlowComponent },
			{ path: ':slug/:stepKey', component: ProductFlowComponent },
			{ path: ':slug/:stepKey/edit/:cartItemId', component: ProductFlowComponent },
			{
				path: ':slug/:stepKey/edit/:cartItemId?productList',
				component: ProductFlowComponent,
			},
		],
	},
]);

/** Product module. */
@NgModule({
	imports: [
		productRouting,
		SharedModule,
		SchemaFormModule,
		VatSelectorComponent,
		IconComponent,
		ZoomableImageComponent,
		LocalizedLengthPipe,
		PrintfileReportComponent,
		UploadMaterialComponent,
		DynamicUploadModule,
		ProductAdditionalInfoComponent,
		MatTabsModule,
		MatTooltipModule,
		MatExpansionModule,
	],
	declarations: [
		ProductFlowComponent,
		DetailsComponent,
		WorkflowSelectorComponent,
		ProductMediaViewerComponent,
		ProductPriceComponent,
		ProductEditorComponent,
		DesignServiceComponent,
		ValidateDesignComponent,
		TemplateSelectorComponent,
		GetProductMediaUrlPipe,
		GetProductFlowButtonLabelPipe,
	],
})
export class ProductModule {}
